import { createContext, useContext, type ReactNode } from "react";
import type { PlatformApiClient } from "./PlatformApiClient";

/**
 * Injects the one `PlatformApiClient` implementation this app runs against. Every page
 * calls `usePlatformClient()` rather than importing `mockPlatformApiClient` directly —
 * `main.tsx` is the single place that decides which implementation is wired up, which is
 * exactly the seam described in `PlatformApiClient.ts`'s doc comment for swapping in a
 * real implementation later.
 */
const ClientContext = createContext<PlatformApiClient | null>(null);

export function PlatformClientProvider({ client, children }: { client: PlatformApiClient; children: ReactNode }) {
  return <ClientContext.Provider value={client}>{children}</ClientContext.Provider>;
}

export function usePlatformClient(): PlatformApiClient {
  const client = useContext(ClientContext);
  if (!client) throw new Error("usePlatformClient() must be used within a <PlatformClientProvider>");
  return client;
}
